import { MenuItem } from './menu.model';

// ══════════════════════════════════════════════
//  SYSA — Super Admin (Plataforma)
//  Solo ve: Empresas
//  idCompany = SYS (no pertenece a ninguna empresa)
// ══════════════════════════════════════════════
export const SysaMenu: MenuItem[] = [
  {
    label: 'Plataforma',
    isTitle: true
  },
  {
    label: 'Empresas',
    icon: 'configuration',
    link: '/business/companies'
  }
];

// ══════════════════════════════════════════════
//  ADMI — Administrador de Negocio
//  Ve el menú completo de operación
//  + Gestión de Locales de su empresa
// ══════════════════════════════════════════════
export const AdminMenu: MenuItem[] = [
  {
    label: 'Principal',
    isTitle: true
  },
  {
    label: 'Dashboard',
    icon: 'dashboard',
    link: '/dashboard'
  },
  {
    label: 'Ventas',
    icon: 'ventas',
    subItems: [
      {
        label: 'Local',
        link: 'location',
      },
      {
        label: 'Reportes',
        link: 'order/reports',
      },
      {
        label: 'Boletas',
        link: 'order/ballot',
      }
      // {
      //   label: 'Facturas',
      //   link: 'order/invoice',
      // }
    ]
  },
  {
    label: 'Gastos',
    icon: 'gastos',
    link: 'expense'
  },
  {
    label: 'Caja',
    icon: 'cash',
    link: 'cashbox'
  },
  {
    label: 'Maestras',
    isTitle: true
  },
  {
    label: 'Maestro de Clientes',
    icon: 'customer',
    link: 'client'
  },
  {
    label: 'Maestro de Productos',
    icon: 'productos',
    link: 'product'
  },
  {
    label: 'Acceso Rápido',
    icon: 'productos',
    link: 'product/favorites'
  },
  {
    label: 'Notas Rápidas',
    icon: 'productos',
    link: 'quick-note'
  },
  {
    label: 'Maestro de Usuarios',
    icon: 'user',
    link: 'user/userlist'
  },
  {
    label: 'Mantenimiento',
    isTitle: true
  },
  {
    label: 'Mis Locales',
    icon: 'ventas',
    link: '/business/premises'
  },
  {
    label: 'Configuraciones',
    icon: 'configuration',
    link: '/configuration'
  }
];

export const CashierMenu: MenuItem[] = [
  {
    label: 'Principal',
    isTitle: true
  },
  {
    label: 'Dashboard',
    icon: 'dashboard',
    link: '/dashboard'
  },
  {
    label: 'Ventas',
    icon: 'ventas',
    subItems: [
      {
        label: 'Local',
        link: 'location',
      },
      {
        label: 'Pedidos',
        link: 'order/orderlist',
      }
    ]
  },
  {
    label: 'Gastos',
    icon: 'gastos',
    link: 'expense'
  },
  {
    label: 'Caja',
    icon: 'cash',
    link: 'cashbox'
  },
  {
    label: 'Maestras',
    isTitle: true
  },
  {
    label: 'Maestro de Clientes',
    icon: 'customer',
    link: 'client'
  },
];

export const WaiterMenu: MenuItem[] = [
  {
    label: 'Principal',
    isTitle: true
  },
  {
    label: 'Ventas',
    icon: 'ventas',
    subItems: [
      {
        label: 'Local',
        link: 'location',
      }
    ]
  }
];
